export class DateUtils {
  public static format(date: Date | string | number = new Date(), format = 'DD/MM/YYYY'): string {
    const localDate = new Date(date);
    const localFormat = format;
    const month = (localDate.getMonth() + 1).toString().padStart(2, '0');
    const day = localDate.getDate().toString().padStart(2, '0');
    const hours = localDate.getHours().toString().padStart(2, '0');
    const minutes = localDate.getMinutes().toString().padStart(2, '0');
    const seconds = localDate.getSeconds().toString().padStart(2, '0');

    return localFormat
      .replace('DD', day)
      .replace('MM', month)
      .replace('YYYY', localDate.getFullYear().toString())
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
  }

  public static getDate(date: string | Date, entryFormat = 'DD/MM/YYYY'): Date {
    if (date && typeof date === 'string' && entryFormat !== 'MM/DD/YYYY') {
      const monthIndex = entryFormat.includes('/')
        ? entryFormat.split('/').findIndex((item) => item === 'MM')
        : entryFormat.split('-').findIndex((item) => item === 'MM');
      const dayIndex = entryFormat.includes('/')
        ? entryFormat.split('/').findIndex((item) => item === 'DD')
        : entryFormat.split('-').findIndex((item) => item === 'DD');
      const yearIndex = entryFormat.includes('/')
        ? entryFormat.split('/').findIndex((item) => item === 'YYYY')
        : entryFormat.split('-').findIndex((item) => item === 'YYYY');

      return new Date(`${date.split('/')[monthIndex]}/${date.split('/')[dayIndex]}/${date.split('/')[yearIndex]}`);
    }

    return new Date(date);
  }
}
